'use strict';

const Alerts = require('lib/alerts');
const log    = require('lib/log')('common-base-router');

module.exports = Backbone.Router.extend({
    view:   null,
    layout: null,

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            log: function() {}
        });

        this.on('route', this.logRouteChange, this);
    },

    route: function(route, name, callback) {
        var f;

        if (!callback) {
            callback = this[name];
        }

        f = function() {
            var args   = arguments;
            var status = {unsaved: false};

            log.info('Triggering navigate event');
            app.events.trigger('navigate', status);

            if (status.unsaved === true) {
                log.info('A view claimed unsaved changes');

                Alerts.show('confirm', {
                    title: 'Unsaved changes',

                    text: status.msg || 'There are unsaved changes. Exiting ' +
                        'this page will result in the changes being discarded.',
                    confirmButtonText: 'Exit',
                    cancelButtonText:  'Stay',
                    callback:          confirm => {
                        if (confirm) {
                            app.events.trigger('hard-exit');

                            this.hidePopups();
                            this.undelegateEvents();
                            app.events.trigger('before:route', {
                                previousFragment:
                                    Backbone.history.previousFragment
                            });
                            callback.apply(this, args);
                            return;
                        }

                        app.mainRouter.navigate(
                            Backbone.history.previousFragment,
                            {trigger: false, replace: true}
                        );
                    }
                });

                return;
            }

            this.hidePopups();
            this.undelegateEvents();
            app.events.trigger('before:route', {
                previousFragment: Backbone.history.previousFragment
            });
            callback.apply(this, arguments);
        };

        return Backbone.Router.prototype.route.apply(this, [route, name, f]);
    },

    undelegateEvents: function() {
        if (this.view && _.isFunction(this.view.undelegateEvents)) {
            this.view.undelegateEvents();
        }

        if (
            !_.isNull(this.layout) &&
            _.isFunction(this.layout.undelegateEvents)
        ) {
            this.layout.undelegateEvents();
        }

        if (
            app.contentView &&
            typeof app.contentView.undelegateEvents === 'function'
        ) {
            app.contentView.undelegateEvents();
        }
    },

    hidePopups: function() {
        if (
            Backbone.history.previousFragment ===
            Backbone.history.getFragment()
        ) {
            return;
        }

        if ($('.modal-backdrop.in')[0]) {
            $('.modal').off().modal('hide');
        }

        Alerts.close();
    },

    logRouteChange: function(route, params) {
        var args = ['Route matched <', route, '>'];

        if (params && params.length > 0 && params[0] !== null) {
            args.push('with params', params);
        } else {
            args.push('with no parameters');
        }

        this.options.log.info.apply(this.options.log, args);
    }
});



// WEBPACK FOOTER //
// ./app/commons/routers/Base.js